import Vue from './../init';

const uri = 'tag';

var customActions = {};

export const TagsResource = Vue.resource(uri, {}, customActions);
